module.exports = function getResource(label) {
    const resources = {
        ratingsAndReviewsGuidelines: 'Ratings & Reviews Guidelines',
        done: 'Done'
    };
    return resources[label];
};
